import React from 'react';
import { useRouter } from 'next/router';
import TitleMask from '@/components/Common/Layout/TitleMask';
import SoloRank from '@/components/Rank/SoloRank';
import { useRanks } from '@/hooks/ranks/useRanks';

function Rank() {
  const router = useRouter();
  const { query } = router;
  const ranks = useRanks({ query });

  return (
    <TitleMask title="랭킹">
      <SoloRank ranks={ranks} />
    </TitleMask>
  );
}

export default Rank;
